'use client'

import React, { useEffect } from 'react'
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal'
import ModalContent from './ModalContent'

const CommsModal = ({ show, onHide, content, isMobile }) => {
  const isPhoneModal = content?.commsCtas?.some(cta => cta.Type === 'Phone')

  useEffect(() => {
    document.documentElement.style.overflowY = show ? 'hidden' : 'scroll'
  }, [show])

  const renderModalContent = () => <ModalContent isMobile={isMobile} content={content} />

  return isMobile ? (
    <ModalMobile
      align="left"
      show={show}
      onHide={onHide}
      padding="0px"
      urlhash=""
      showOverlayBackground
      disableOverlayClose={false}
      bodyMargin="0px"
      closeButtonStyles={{
        right: '20px',
        top: '20px',
        backgroundColor: '#0A0A0A0F',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        maxWidth: '32px !important',
        maxHeight: '32px !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
        zIndex: '9999',
        position: 'absolute',
      }}>
      {renderModalContent()}
    </ModalMobile>
  ) : (
    <ModalDesktop
      align="right"
      show={show}
      onHide={onHide}
      padding="0px"
      urlhash=""
      disableOverlayClose={false}
      styles={
        isPhoneModal
          ? {
              width: '957px',
              borderRadius: '32px',
              overflow: 'hidden',
              ':nth-child(2)': {
                marginTop: '0px',
              },
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
              maxWidth: '957px',
            }
          : {
              width: '957px',
              borderRadius: '32px',
              overflow: 'hidden',
              ':nth-child(2)': {
                marginTop: '0px',
              },
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
              maxWidth: '957px',
            }
      }
      closeButtonStyles={{
        right: '26px',
        top: '24px',
        backgroundColor: '#1212128f',
        width: '32px',
        height: '32px',
        maxWidth: '32px !important',
        maxHeight: '32px !important',
        borderRadius: '50%',
        zIndex: '9999',
        position: 'absolute',
        svg: {
          filter: 'invert(100%) sepia(100%) saturate(0%) hue-rotate(262deg) brightness(108%) contrast(101%)',
        },
        padding: '4px',
      }}>
      {renderModalContent()}
    </ModalDesktop>
  )
}

export default CommsModal
